export default "__VITE_ASSET__Ch7cOGdF__"